


import { enqueueSnackbar } from 'notistack';

import { Button, ButtonProps } from '@mui/material';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import { useOrgHierarchy } from 'src/hooks/auth/use-org-hierarchy';

import { useTranslate } from 'src/locales';

import Iconify from 'src/components/iconify';

import { TenantHierarchyLevel } from 'src/types/enums';

// ----------------------------------------------------------------------

type Props = {
  label?: string;
} & ButtonProps;

export default function FeatureLockedButton({
  label,
  ...buttonProps
}: Props) {

  const { t } = useTranslate();
  const router = useRouter();

  const tenantHierarchy = useOrgHierarchy();

  const handleClick = () => {
    if (tenantHierarchy === TenantHierarchyLevel.PARENT) {
      router.push(paths.dashboard.admin.billing.root);
    } else {
      enqueueSnackbar(t('billing.sub_tenant_feature_locked_message'), { variant: 'warning' });
    }
  }

  return (
    <Button
      variant="outlined"
      size="small"
      startIcon={<Iconify icon="ic:twotone-lock" width={20} height={20} />}
      onClick={handleClick}
      {...buttonProps}
    >
      {label ?? t('billing.feature_locked')}
    </Button>
  );
}
